import { axiosLasta } from 'config';

export const updateUserEmail = async (payload) => {
    const response = await axiosLasta.put(`/email`, payload);
    return response?.data;
};

export const fetchAuthWithoutValidateStatus = async () => {
    const response = await axiosLasta.get('/auth');

    return response?.data;
};

export const refreshToken = () => axiosLasta.post('/auth/refresh');
